import { createPortal } from 'react-dom'
import { useTranslation } from 'react-i18next'

import { Spinner, Typography } from '@maistodos/design-system-web'

import Modal from '@/components/Modal'

import { Container } from './styles'
import { PaymentRedirectModalProps } from './types'

export const PaymentRedirectModal = ({
  isOpen,
  title,
  description,
}: PaymentRedirectModalProps) => {
  const { t } = useTranslation()

  return createPortal(
    <Modal isOpen={isOpen} dismissible={false}>
      <Container data-testid="payment-redirect-modal">
        <Spinner color="brand500" fontSize="h1" />
        <Typography
          variant="h6"
          as="h6"
          weight="bold"
          color="neutral600"
          align="center"
          css={{ margin: 0 }}
        >
          {title ?? t('Estamos processando seu pagamento.')}
        </Typography>
        <Typography variant="large" as="p" color="neutral500" align="center">
          {description ??
            t('Aguarde, você será redirecionado para concluir o pagamento.')}
        </Typography>
      </Container>
    </Modal>,
    document.body,
  )
}
